import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import {
  addCourse as addCourseApi,
  updateCourse as updateCourseApi,
  getCourse as getCourseApi,
  deleteCourse as deleteCourseApi,
} from "../../helpers/";

// actions
import {
  courseApiResponseSuccess,
  courseApiResponseError,
  getCourse,
} from "./actions";

// constants
import { CourseActionTypes } from "./constants";
import { updateCourseEnrollmentApi } from "../../helpers/api/course";

interface categoryData {
  payload: {
    id: number;
    name: string;
    categoryId: string;
    amount: string;
    offerAmount: string;
    description: string;
    description_ar: string;
    name_arabic: string;
    image: any;
    video: any;
    banner: any;
    enroll_text: string;
    enroll_text_ar: string;
    duration: any;
    enr_count: any;
    course_type:string;
    sortOrder: any;
    checked: any;
    filter: any;
    status: any;
  };
  type: string;
}

function* createCourse({
  payload: {
    name,
    categoryId,
    amount,
    description,
    name_arabic,
    description_ar,
    image,
    offerAmount,
    video,
    banner,
    enroll_text,
    enroll_text_ar,
    duration,
    enr_count,
    course_type,
    sortOrder,
    filter,
    status,
  },
  type,
}: categoryData): SagaIterator {
  try {
    const response = yield call(addCourseApi, {
      name,
      categoryId,
      amount,
      name_arabic,
      description,
      description_ar,
      image,
      offerAmount,
      video,
      banner,
      enroll_text,
      enroll_text_ar,
      duration,
      enr_count,
      course_type,
      sortOrder,
    });

    const categoryData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      courseApiResponseSuccess(CourseActionTypes.CREATE_COURSE, categoryData)
    );
    yield put(getCourse(filter, status));
  } catch (error: any) {
    yield put(courseApiResponseError(CourseActionTypes.CREATE_COURSE, error));
  }
}

function* updateCourse({
  payload: {
    id,
    name,
    categoryId,
    amount,
    name_arabic,
    description,
    description_ar,
    image,
    offerAmount,
    video,
    banner,
    enroll_text,
    enroll_text_ar,
    duration,
    enr_count,
    course_type,
    sortOrder,
    filter,
    status,
  },
}: categoryData): SagaIterator {
  try {
    const response = yield call(updateCourseApi, id, {
      name,
      categoryId,
      amount,
      name_arabic,
      description,
      description_ar,
      image,
      offerAmount,
      video,
      banner,
      enroll_text,
      enroll_text_ar,
      duration,
      enr_count,
      course_type,
      sortOrder,
    });
    const categoryData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      courseApiResponseSuccess(CourseActionTypes.UPDATE_COURSE, categoryData)
    );
    yield put(getCourse(filter, status));
  } catch (error: any) {
    yield put(courseApiResponseError(CourseActionTypes.UPDATE_COURSE, error));
  }
}

function* getCourses({ payload: { filter, status } }: any): SagaIterator {
  try {
    const response = yield call(getCourseApi, filter, status);
    const categoryData = response?.data?.courses;

    yield put(
      courseApiResponseSuccess(CourseActionTypes.GET_COURSE, categoryData)
    );
  } catch (error: any) {
    yield put(courseApiResponseError(CourseActionTypes.GET_COURSE, error));
  }
}

function* deleteCourse({
  payload: { id, checked, filter, status },
}: categoryData): SagaIterator {
  try {
    const response = yield call(deleteCourseApi, id, checked);
    const categoryData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      courseApiResponseSuccess(CourseActionTypes.DELETE_COURSE, categoryData)
    );
    yield put(getCourse(filter, status));
  } catch (error: any) {
    yield put(courseApiResponseError(CourseActionTypes.DELETE_COURSE, error));
  }
}
function* UpdateCourseEnr({
  payload: { id, checked, filter, status },
}: categoryData): SagaIterator {
  try {
    const response = yield call(updateCourseEnrollmentApi, id, { checked });
    const categoryData = response.data.message;


    // NOTE - You can change this according to response format from your api

    yield put(
      courseApiResponseSuccess(
        CourseActionTypes.UPDATE_COURSE_ENROLLMENT,
        categoryData
      )
    );
    
    
    yield put(getCourse(filter, status));
  } catch (error: any) {
    yield put(
      courseApiResponseError(CourseActionTypes.UPDATE_COURSE_ENROLLMENT, error)
    );
  }
}

export function* watchCreateCourse() {
  yield takeEvery(CourseActionTypes.CREATE_COURSE, createCourse);
}
export function* watchUpdateCourse() {
  yield takeEvery(CourseActionTypes.UPDATE_COURSE, updateCourse);
}
export function* watchGetCourse() {
  yield takeEvery(CourseActionTypes.GET_COURSE, getCourses);
}

export function* watchDeleteCourse() {
  yield takeEvery(CourseActionTypes.DELETE_COURSE, deleteCourse);
}

export function* watchUpdateCourseEnr() {
  yield takeEvery(CourseActionTypes.UPDATE_COURSE_ENROLLMENT, UpdateCourseEnr);
}

function* courseSaga() {
  yield all([
    fork(watchCreateCourse),
    fork(watchUpdateCourse),
    fork(watchDeleteCourse),
    fork(watchGetCourse),
    fork(watchUpdateCourseEnr),
  ]);
}

export default courseSaga;
